


























import Vue from 'vue';
import LanguageSelector from '@/components/LanguageSelector.vue';
import QuizStatus from '@/models/QuizStatus';

// eslint-disable-next-line import/no-cycle
import QuizUtils from '@/libs/QuizUtils';

export default Vue.extend({
  components: {
    LanguageSelector,
  },
  data() {
    return {
      quizCodeStatus: -1,
      QuizStatus,
    };
  },
  computed: {
    quizCode(): string | null {
      return this.$store.state.code;
    },
  },
  created() {
    this.quizCodeStatus = this.$route.query.quizCodeStatus as unknown as number;
  },
  methods: {
    sendResultViewer() {
      if (this.quizCode) {
        QuizUtils.sendAnswerReport(this.quizCode);
      }
    },
  },
});
